import React from 'react';
import { Grid, Stack, Box, Badge, Tooltip, IconButton } from '@mui/material';
import {
  StyledCard, StyledCardTitle, DataGridProps, StyledDataGrid, TableBadge,/*, CustomInputLabel, CustomTextField, InputProps, CustomStyle, CustomSelect, SelectInputProps, CustomAutocomplete*/ 
  FlexDiv 
} from '../../../../../custom/components';
import flightStyles from '../../flightsfolder.module.css';
import styles from '../../../../../custom/style.module.css';
import discrepancyStyles from './discrepancy.module.css';
import { AddIcon, AttachmentIcon, DeleteIcon, EditIcon, ExcelIcon } from '../../../../../custom/constants';
import { Comment } from '@mui/icons-material';
import ManifestSummaryContainer from '../../summary/ManifestSummaryContainer';
import Attachment from './Attachment';
import DocModalContainer from 'components/pages/common/docModal/DocModalContainer';
import AddDiscrepancyModal from './AddDiscrepancyModal';
import { CsvToExcel } from 'custom/export';
import moment from 'moment';
import RemarkModal from 'components/pages/common/RemarkModal';
import cookies from 'utils/cookies';

const Discrepancy = (props) => {

  const { showReportModal } = props;
  const apiRef = React.useRef(null);
  const filename = `${props.flight?.airline?.code}${props.flight?.flight_no}/${moment(props.flight?.flight_date).format('DDMMMYY').toUpperCase()}`;

  const columns = [
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 130,
      flex: 1,
    },
    {
      field: 'uld_no',
      headerName: 'ULD',
      minWidth: 120,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <>
            {row.uld_no && row.uld_no != 'null' ? row.uld_no : <div className={styles.ml4}>-</div>}
          </>
        );
      }
    },
    {
      field: 'handled_as',
      headerName: 'Handled As',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'segment',
      headerName: 'Segment',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <>
            {row.segment && row.segment != 'null' ? row.segment : <div className={styles.ml4}>-</div>}
          </>
        );
      }
    },
    {
      field: 'uld_type',
      headerName: 'ULD Type',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <>
            {row.uld_type && row.uld_type != 'null' ? row.uld_type : <div className={styles.ml4}>-</div>}
          </>
        );
      }
    },
    {
      field: 'awb_no',
      headerName: 'Airwaybill',
      minWidth: 140,
      flex: 1,
    },
    {
      field: 'prod_code',
      headerName: 'Product',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        if (row.products && row.products.length > 0) {
          const names = row.products.map((product) => product.name).join(', ');
          return (
            <Tooltip title={names}>
              <span style={
                { 
                  cursor: 'pointer', 
                  color: '#1976d2' 
                }
              }>
                {row.products.length} Product{row.products.length > 1 ? 's' : ''}
              </span>
            </Tooltip>
          );
        } else {
          return '-';
        }
      }
    },
    {
      field: 'org',
      headerName: 'Origin',
      minWidth: 80,
      flex: 1,
    },
    {
      field: 'dest',
      headerName: 'Dest',
      minWidth: 80,
      flex: 1,
    },
    {
      field: 't_pcs',
      headerName: 'Total Pcs',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 't_wgt',
      headerName: 'Total Wgt',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'd_pcs',
      headerName: 'Dscpy Pcs',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'd_wgt',
      headerName: 'Dscpy Wgt',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'remark',
      headerName: 'Remarks',
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: ({ row }) => {
        return (row?.remark ? <Badge color='secondary' variant='dot'>            
          <IconButton
            onClick={() => props.handleRemark('remark', row?.remark)}
            className={`${styles.p0}`}
            size='small'
            color='primary'>
            <Comment fontSize='inherit' />
          </IconButton>
        </Badge>
          : <IconButton
            className={`${styles.p0}`}
            size='small'
            disabled
          >
            <Comment fontSize='inherit' />
          </IconButton>                      
        );
      }
    },
    {
      field: 'docs',
      headerName: 'Attachment',
      minWidth: 100,
      flex: 1,
      disableExport: true,
      align: 'center',
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <>
            <TableBadge color='error' badgeContent={row?.docs?.length} sx={{ position: 'absolute' }}>
              <AttachmentIcon title='Add/View Attachment' onClick={() => props.handleDoc(row)} />
            </TableBadge>
          </>
        );
      }
    },
    ...(!showReportModal ?
      [{
        field: 'action',
        headerName: 'Action',
        headerAlign: 'center',
        align: 'center',
        minWidth: 80,
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
        disableExport: true,
        renderCell: ({ row }) => {
          return (
            <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
              <EditIcon onClick={() => props.onEdit(row)} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep'} />
              <DeleteIcon onClick={(e) => props.onDelete(row.id, e.target)} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep'} />
            </Stack>
          );
        }
      },] : []
    )
  ];

  const handleExport = async () => {
    const csvData = await apiRef.current.getDataAsCsv();
    CsvToExcel(csvData, `Discrepancy - ${filename}`);
  };

  return (
    <>
      <Attachment
        handlePopover={props.handlePopover}
        anchorEl={props.anchorEl}
        attachment={props.attachment}
        doc={props.doc}
        onDeleteAttachment={props.onDeleteAttachment}
        disableFlightFields={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep'}
      />
      <Grid container spacing={3} sx={{ marginTop : props.showRejectedMessage || props.showNilMessage ? '10px' : '-24px' }}>
        <Grid item xs={12}
          className={styles.pt0}
          sx={{
            [`& .${flightStyles.summaryCollapse}`]: {
              marginTop: '-12px !important',
              transition: 'margin-top 0.3s ease-in-out',
            },
            [`& .${flightStyles.summaryShow}`]: {
              marginTop: '0px !important',
              transition: 'margin-top 0.3s ease-in-out',
            } 
          }}>
          <ManifestSummaryContainer 
            showReportModal={props.showReportModal} 
            nil={props.nil_manifest} 
            discrepancyList={props.discrepancyList} 
            printFunction={props.printFunction} /> 
        </Grid>

        <Grid item xs={12} className={styles.pt0}>
          <StyledCard>
            <FlexDiv><StyledCardTitle> List of Discrepancies</StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={2} alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-16px'}>
              <AddIcon onClick={() => props.handleOpen('add')} title='Add Discrepancy' disabled={props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep'} />
              <ExcelIcon title='Download File' onClick={handleExport} className={`${styles.tableIcon} ${discrepancyStyles.discExcelIcon}`} />
            </Stack>
            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${discrepancyStyles.discTableOuter}`}>
                <StyledDataGrid
                  {...DataGridProps}
                  rows={props.discrepancyList}
                  columns={columns}
                  apiRef={apiRef}
                  param={props.discrepancyList?.length}
                  sx={{
                    width: {
                      xs: 'fit-content',
                      xl: 'auto' 
                    } 
                  }}
                />
              </Box>
            </div>
          </StyledCard>
        </Grid>

      </Grid>

      <DocModalContainer 
        disableFlightFields={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep'}
      />
      <AddDiscrepancyModal
        modal={props.modal}
        handleOpen={props.handleOpen}
        discrepancyFields={props.discrepancyFields}
        discrepancyErrors={props.discrepancyErrors}
        onClose={props.onClose}
        addEditDiscrepancy={props.addEditDiscrepancy}
        action={props.action}
        onChange={props.onChange}
        onULDChange={props.onULDChange}
        onAWBChange={props.onAWBChange}
        onInputChange={props.onInputChange}
        getULDData={props.getULDData}
        productsList={props.productsList}
        anchorRef={props.anchorRef}
        onBlurAwb={props.onBlurAwb}
        confirmModalShown={props.confirmModalShown}
        closeConfirmModal={props.closeConfirmModal}
        confirmModal={props.confirmModal}
        handleIgnoreError={props.handleIgnoreError}
        ignoreError={props.ignoreError}
      />

      {
        props.modal === 'remark'&& <RemarkModal
          modal={props.modal}
          onClose={props.handleRemarkClose}
          remark={props.modalData}
        />
      }
    </>
  );
};

export default Discrepancy;